// The "clever detail" from DESIGN.md \u00a77: hovering any rule code anywhere on the site pops a tiny
// tooltip confirming it's a real, enforced rule \u2014 not placeholder copy.
export function RuleChip({ code }: { code: string }) {
  return (
    <span className="rule-chip">
      {code}
      <span className="rule-tooltip" role="tooltip">
        This is a real rule the engine enforces — not a placeholder.
      </span>
    </span>
  );
}
